import styled from 'styled-components'
import colorConfig from '../../colorConfig'

const FooterArea = styled.div`
    padding: 37px 50px 50px;
    background-color: ${colorConfig.footer_bg};
    font-family: "RM Neue", sans-serif;
    font-size: 15px;
    min-height: 300px;
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
    column-gap: 80px;
    align-items: start;
    a,
    p,
    span {
      color: inherit;
      font-size: inherit;
      line-height: 1.35;
      text-decoration: none;
      font-weight: 400;
    }
    span {
      color: #fff;
      font-weight: 600;
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    li {
      color: #c0bcc2;
      margin-top: 14px;
    }
    @media (max-width: 900px) {
      grid-template-columns: 1fr;
      row-gap: 40px;
      column-gap: 50px;
      min-height: 800px;
    }
    @media (max-width: 600px) {
      padding: 32px 24px 40px;
      grid-template-columns: 1fr;
      row-gap: 32px;
      font-size: 18px;
      min-height: 800px;
    }
    @media print {
      display: none;
    }
`;
export default FooterArea